import * as React from 'react';
import { useDispatch } from 'umi';

import { LeadModel } from '@/typings/models/Lead';
import LeadPriorityDropdownFilters, {
  LeadPriorityPresentation,
} from '@/components/Filters/LeadPriorityDropdownFilters';
import styles from './index.less';

const getLeadPriority = (lead: LeadModel) => lead?.priority?.value;
const LeadPriority = ({ lead, isCard, readonly }: { lead: LeadModel, isCard?: boolean, readonly?: boolean }) => {
  const dispatch = useDispatch();
  const onChangeStatus = (newPriority) => {
    dispatch({
      type: 'leads/edit',
      payload: {
        priority: newPriority?.value || newPriority,
        leadId: lead.id,
      },
    });
  };
  const priority = getLeadPriority(lead) || 0;

  return <LeadPriorityDropdownFilters
    className={styles.leadPriorityContainer}
    selectProps={{
      bordered: false,
      allowClear: false,
      size: isCard ? 'small' : 'medium',
    }}
    readonly={readonly}
    filterMode={'select'}
    onChange={onChangeStatus}
    value={priority}
  />;
};

const propsAreEqual = (prevProps, nextProps) => {
  if (prevProps.value !== nextProps.value)
    return false;

  if (prevProps.lead?.id !== nextProps.lead?.id)
    return false;

  const prevPriority = getLeadPriority(prevProps.lead);
  const newPriority = getLeadPriority(nextProps.lead);
  return prevPriority === newPriority;
};
const MemoizedLeadPriority = React.memo(LeadPriority, propsAreEqual);
export default function LeadPriorityWrapper(props) {
  return <MemoizedLeadPriority {...props} value={getLeadPriority(props.lead)} />;
}
